import { Link, Typography } from '@iheartjane/reefer';
import type { Nullable } from '@iheartjane/types';
import { useState } from 'react';

import type { TextBannerViewModel } from '@jane/bloom/viewModels/communicationBanner';

import styles from './textBanner.module.css';

type TextBannerProps = {
  communicationBanner: Nullable<TextBannerViewModel>;
};

export function TextBanner({ communicationBanner }: TextBannerProps) {
  const [isExpanded, setIsExpanded] = useState(
    communicationBanner?.is_expanded
  );
  if (!communicationBanner?.enabled) return null;

  return (
    <div className={styles['container']}>
      <div className={styles['firstLine']}>
        <Typography
          as="span"
          variant="body-bold"
          color="text-main"
          maxLines={1}
          width="100%"
        >
          {communicationBanner.title}
        </Typography>

        {communicationBanner.message && (
          <div className={styles['viewMoreLess']}>
            <Link
              className={styles['toggleText']}
              onClick={() => setIsExpanded(!isExpanded)}
              typography="body"
            >
              {isExpanded ? 'View less' : 'View more'}
            </Link>
          </div>
        )}
      </div>

      {isExpanded && (
        <div
          className={styles['message']}
          dangerouslySetInnerHTML={{
            __html: communicationBanner?.message || '',
          }}
        />
      )}
    </div>
  );
}
